module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {}, [_vm._l((_vm.Naloga), function(koren, key, index) {
    return (typeof(koren) !== 'object') ? _c('span', {
      key: '0-' + key,
      staticClass: "form-group"
    }, [(key !== 'guid') ? _c('span', [(key !== 'exerciseId') ? _c('span', [_c('label', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Naloga[key]),
        expression: "Naloga[key]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.Naloga[key])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.Naloga, key, $event.target.value)
        }
      }
    })]) : _vm._e()]) : _vm._e()]) : _vm._l((koren), function(nivo1, key1, index1) {
      return _c('span', [(typeof(nivo1) !== 'object') ? _c('span', [(key1 !== 0) ? _c('span', [(key1 === 'sl' && index === 1) ? _c('label', [_vm._v(_vm._s(_vm.$t('pages.editexercise.title')))]) : (key1 === 'sl' && index === 2) ? _c('label', [_vm._v(_vm._s(_vm.$t('pages.editexercise.description')))]) : _c('label', [_vm._v(_vm._s(key1))]), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.Naloga[key][key1]),
          expression: "Naloga[key][key1]"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (_vm.Naloga[key][key1])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(_vm.Naloga[key], key1, $event.target.value)
          }
        }
      })]) : _vm._e()]) : _vm._l((nivo1), function(nivo2, key2) {
        return _c('span', [(typeof(nivo2) !== 'object') ? _c('span', [(key2 !== 'guid') ? _c('span', [_c('label', [_vm._v(_vm._s(key2))]), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.Naloga[key][key1][key2]),
            expression: "Naloga[key][key1][key2]"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text"
          },
          domProps: {
            "value": (_vm.Naloga[key][key1][key2])
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.Naloga[key][key1], key2, $event.target.value)
            }
          }
        })]) : _vm._e()]) : _vm._l((nivo2), function(nivo3, key3) {
          return _c('span', [(typeof(nivo3) !== 'object') ? _c('span', [_c('label', [_vm._v(_vm._s(key3))]), _vm._v(" "), _c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (_vm.Naloga[key][key1][key2][key3]),
              expression: "Naloga[key][key1][key2][key3]"
            }],
            staticClass: "form-control",
            attrs: {
              "type": "text"
            },
            domProps: {
              "value": (_vm.Naloga[key][key1][key2][key3])
            },
            on: {
              "input": function($event) {
                if ($event.target.composing) { return; }
                _vm.$set(_vm.Naloga[key][key1][key2], key3, $event.target.value)
              }
            }
          })]) : _vm._l((nivo3), function(nivo4, key4) {
            return _c('span', [(typeof(nivo4) !== 'object') ? _c('span', [(key4 !== 'guid') ? _c('span', [_c('label', [_vm._v(_vm._s(key4))]), _vm._v(" "), _c('input', {
              directives: [{
                name: "model",
                rawName: "v-model",
                value: (_vm.Naloga[key][key1][key2][key3][key4]),
                expression: "Naloga[key][key1][key2][key3][key4]"
              }],
              staticClass: "form-control",
              attrs: {
                "type": "text"
              },
              domProps: {
                "value": (_vm.Naloga[key][key1][key2][key3][key4])
              },
              on: {
                "input": function($event) {
                  if ($event.target.composing) { return; }
                  _vm.$set(_vm.Naloga[key][key1][key2][key3], key4, $event.target.value)
                }
              }
            })]) : _vm._e()]) : _vm._l((nivo4), function(nivo5, key5) {
              return _c('span', [(typeof(nivo5) !== 'object') ? _c('span', [_c('label', [_vm._v(_vm._s(key5))]), _vm._v(" "), _c('input', {
                directives: [{
                  name: "model",
                  rawName: "v-model",
                  value: (_vm.Naloga[key][key1][key2][key3][key4][key5]),
                  expression: "Naloga[key][key1][key2][key3][key4][key5]"
                }],
                staticClass: "form-control",
                attrs: {
                  "type": "text"
                },
                domProps: {
                  "value": (_vm.Naloga[key][key1][key2][key3][key4][key5])
                },
                on: {
                  "input": function($event) {
                    if ($event.target.composing) { return; }
                    _vm.$set(_vm.Naloga[key][key1][key2][key3][key4], key5, $event.target.value)
                  }
                }
              })]) : _vm._l((nivo5), function(nivo6, key6) {
                return _c('span', [(typeof(nivo6) !== 'object') ? _c('span', [_c('label', [_vm._v(_vm._s(key6))]), _vm._v(" "), _c('input', {
                  directives: [{
                    name: "model",
                    rawName: "v-model",
                    value: (_vm.Naloga[key][key1][key2][key3][key4][key5][key6]),
                    expression: "Naloga[key][key1][key2][key3][key4][key5][key6]"
                  }],
                  staticClass: "form-control",
                  attrs: {
                    "type": "text"
                  },
                  domProps: {
                    "value": (_vm.Naloga[key][key1][key2][key3][key4][key5][key6])
                  },
                  on: {
                    "input": function($event) {
                      if ($event.target.composing) { return; }
                      _vm.$set(_vm.Naloga[key][key1][key2][key3][key4][key5], key6, $event.target.value)
                    }
                  }
                })]) : _vm._l((nivo6), function(nivo7, key7) {
                  return _c('span', [(typeof(nivo7) !== 'object') ? _c('span', [_c('label', [_vm._v(_vm._s(key7))]), _vm._v(" "), _c('input', {
                    directives: [{
                      name: "model",
                      rawName: "v-model",
                      value: (_vm.Naloga[key][key1][key2][key3][key4][key5][key6][key7]),
                      expression: "Naloga[key][key1][key2][key3][key4][key5][key6][key7]"
                    }],
                    staticClass: "form-control",
                    attrs: {
                      "type": "text"
                    },
                    domProps: {
                      "value": (_vm.Naloga[key][key1][key2][key3][key4][key5][key6][key7])
                    },
                    on: {
                      "input": function($event) {
                        if ($event.target.composing) { return; }
                        _vm.$set(_vm.Naloga[key][key1][key2][key3][key4][key5][key6], key7, $event.target.value)
                      }
                    }
                  })]) : _c('span', [_vm._v("\n                                If you can see me there is a bug\n                              ")])])
                })], 2)
              })], 2)
            })], 2)
          })], 2)
        })], 2)
      })], 2)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1fef084c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fef084c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/EditExercise.vue
// module id = 1419
// module chunks = 1